import { getBreakpoint } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import Swiper, { Navigation, Pagination, SwiperOptions, Autoplay, EffectFade, Controller, EffectCoverflow, EffectCube } from "swiper";

const homeSlider = createComponent(() => ({
    setup () {
        const config: SwiperOptions = {
            modules: [
                Autoplay,
                EffectFade,
                Pagination,
            ],
            pagination: {
                el: this.$refs.pagination,
                type: 'bullets',
                clickable: true,
                bulletActiveClass: '!bg-gold md:!bg-white',
                bulletClass: 'inline-block bg-gray-400 rounded-full h-3 w-3 cursor-pointer hover:bg-gold/75 transition-colors',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            slidesPerView: 1,
            speed: 750,
            autoplay: {
                delay: 3000,
            },
            on: {
                slideChangeTransitionEnd (swiper) {
                    if(swiper.realIndex == 0) {
                        const slideImgs = swiper.wrapperEl.querySelectorAll('.swiper-slide-active .lazy.loading');

                        slideImgs.forEach((item) => {
                            item.classList.add('opacity-100');
                        })
                    }
                },
            },
        }

        new Swiper(this.$el, config);
    }
}));

const brandsSlider = createComponent(() => ({
    setup () {
        const config: SwiperOptions = {
            modules: [
                Autoplay,
                Navigation,
            ],
            navigation: {
                prevEl: this.$refs.prev,
                nextEl: this.$refs.next,
            },
            slidesPerView: 3,
            speed: 750,
            loop: true,
            spaceBetween: 16,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                [getBreakpoint('md')]: {
                    slidesPerView: 4,
                },
                [getBreakpoint('lg')]: {
                    slidesPerView: 5,
                },
            },
            on: {
                init (swiper) {
                    swiper.wrapperEl.querySelectorAll('img').forEach(img =>
                        img.classList.add('lazy')
                    );
                },
            },
        }

        new Swiper(this.$el, config);
    },
}));

const contentSlider = createComponent(() => ({
    setup () {
        const imgConfig: SwiperOptions = {
            modules: [
                EffectFade,
            ],
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 750,
            loop: true,
            on: {
                init (swiper) {
                    swiper.wrapperEl.querySelectorAll('img').forEach(img =>
                        img.classList.add('lazy')
                    );
                },
            },
        }

        const contentConfig: SwiperOptions = {
            modules: [
                Navigation,
                Controller,
                Pagination,
            ],
            pagination: {
                el: this.$refs.pagination,
                type: 'bullets',
                clickable: true,
                bulletActiveClass: '!bg-gold',
                bulletClass: 'inline-block bg-gray-400 rounded-full h-3 w-3 cursor-pointer hover:bg-gold/75 transition-colors',
            },
            navigation: {
                prevEl: null,
                nextEl: this.$refs.next,
            },
            slidesPerView: 1,
            speed: 750,
            loop: true,
            controller: {
                control: new Swiper(this.$refs.img, imgConfig)
            }
        }

        new Swiper(this.$refs.content, contentConfig);
    }
}));

const bannerHeaderSlider = createComponent(() => ({
    setup () {
        const config: SwiperOptions = {
            modules: [
                Autoplay,
                EffectFade
            ],
            effect: 'fade',
            loop: true,
            speed: 2000,
            fadeEffect: {
                crossFade: false
            },
            autoplay: {
                delay: 3000,
            },
        }
        new Swiper(this.$el, config);
    }
}));


export default {
    homeSlider,
    brandsSlider,
    contentSlider,
    bannerHeaderSlider
};
